import { connect } from 'react-redux';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { Cart, CartSolid } from '@core-ds/icons/24';
import Dropdown from './dropdown';
import Header from './mini_cart/header';
import Body from './mini_cart/body';
import Footer from './mini_cart/footer';

const Container = styled.div`
   width: 350px;
   text-align: left;
`;

const CartIcon = styled(Cart)`
   color: ${color.gray[400]};
`;

const CartSolidIcon = styled(CartSolid)`
   color: ${color.gray[50]};
`;

const mapStateToProps = (state: any) => ({
   products: state.headerState.miniCart.products,
});

const MiniCartDropdown = ({ products }: { products: any[] }) => {
   const hideMiniCart = () => {
      window.location = window.shared_constants.BaseURI('TAG_CHECKOUT_CART');
   };

   const simpleMiniCart = products.length > 10;
   const CurrentCartIcon = products.length ? CartSolidIcon : CartIcon;

   return (
      <Dropdown
         id="miniCart"
         icon={
            <CurrentCartIcon aria-label="my cart" id="miniCartDropdownToggle" focusable="false" />
         }
         hasBadge={!!products.length}
         wait={simpleMiniCart && hideMiniCart}
      >
         <Container id={simpleMiniCart ? 'hydra-mini-cart-simple' : ''}>
            <div className="mini-cart hydra-mini-cart header-dropdown">
               <Header />
               <Body />
               <Footer />
            </div>
         </Container>
      </Dropdown>
   );
};

export default connect(mapStateToProps)(MiniCartDropdown);
